











































import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

import BaseText from '@/base/app/components/atoms/BaseText.vue';
import HintIcon from '@/base/app/components/molecules/HintIcon.vue';

import { PasswordFormValue, PropsPasswordForm, usePasswordForm } from './PasswordFormComposable';

type Props = PropsPasswordForm;

export default defineComponent({
  name: 'AccountPasswordForm',
  components: { BaseText, HintIcon },
  model: { prop: 'value', event: 'submit' },
  props: {
    value: { type: Object as PropType<PasswordFormValue>, required: true },
    label: { type: String, required: true },
    showForcePasswordChange: { type: Boolean, default: false },
    height: { type: String, default: undefined },
  },
  emits: ['submit'],
  setup(props: Props, { emit }: SetupContext) {
    return usePasswordForm(props, emit);
  },
});
